import styled from "styled-components";

export const ObraArquivadaStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 70px;

  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    
    span {
      margin-left: 24px;
      margin-right: 26px;
      
      span {
        margin-left: 0px;
        margin-right: 0px;
        color: ${({ theme }) => theme.colors.primary.onPrimary};
        font-size: 14px;
        line-height: 32px;
      }
    }

    strong {
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }
  }

  span {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 36px;
    cursor: pointer;

    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }

  .linkDesarquivar {

    &:hover {
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }
  }
`;

export const TextWrap = styled.div`
  padding: 30px;
`;
